import React from 'react';
import { ChevronDown, ChevronUp } from "../../icons";

import { createStyles } from "./styles";

var SortButton = function SortButton(_ref) {var order = _ref.order,onClick = _ref.onClick;
  var classes = createStyles();
  return /*#__PURE__*/(
    React.createElement("button", { id: "sort", type: "button", onClick: onClick && onClick, className: classes.button },
    order === 'ASC' ? /*#__PURE__*/React.createElement(ChevronUp, { width: "2.4rem" }) : /*#__PURE__*/React.createElement(ChevronDown, { width: "2.4rem" })));


};

export default SortButton;
//# sourceMappingURL=index.js.map